/**
 * @file: groupPlanDetails.ts
 *
 * Fold the flat, order-sorted detail rows into per-order groups. The server
 * sorts by `order_no` (then detail-creation time), so every row sharing an
 * order is contiguous — a single linear pass yields one group per order, and
 * the grouping is stable across pagination appends (a group never splits).
 */

import { MaintenancePlanDetailListItem } from '@euler/model/task-detail';

export interface PlanDetailGroup {
  orderNo: string;
  /** First row of the group — its denormalized columns drive the header. */
  header: MaintenancePlanDetailListItem;
  items: MaintenancePlanDetailListItem[];
}

export function groupPlanDetails(
  rows: MaintenancePlanDetailListItem[],
): PlanDetailGroup[] {
  const groups: PlanDetailGroup[] = [];
  for (const row of rows) {
    const last = groups[groups.length - 1];
    if (last && last.orderNo === row.orderNo) {
      last.items.push(row);
    } else {
      groups.push({ orderNo: row.orderNo, header: row, items: [row] });
    }
  }
  return groups;
}
